// Lucide icon: lock (https://lucide.dev/icons/lock)
import { Lock } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconLock = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Lock />
    </IconComponentStyled>
  )
}
